import jwtDecode from 'jwt-decode'

// Excepción temporal (8 oct 2026). Policía DEANT y las hijas vivas ese día.
// Se quita cuando esos usuarios entren con avl:client_id:2.
export const DEANT_ROOT_AGENCY_ID = 356
export const DEANT_AGENCY_IDS = [356, 357, 360, 362, 366]

/**
 * Cliente del access token (scope avl:client_id). Sin scope o con valor inválido, es 1.
 * @returns {number}
 */
export function clientIdFromAccessToken() {
  try {
    const token = localStorage.getItem('accessToken')
    if (!token) return 1
    const decoded = jwtDecode(token)
    const scope = typeof decoded.scope === 'string' ? decoded.scope : ''
    const entry = scope.split(' ').find(item => item.indexOf('avl:client_id:') === 0)
    if (!entry) return 1
    const id = Number(entry.split(':')[2])
    return Number.isInteger(id) && id > 0 ? id : 1
  } catch (e) {
    return 1
  }
}

/**
 * medellin: seis capas de cliente 1.
 * gobernacion: cuadrante, estación y EMPAS de cliente 2.
 * all: seis capas, y cuadrante/estación juntan cliente 1 y 2. EMPAS no entra aquí.
 * @returns {'medellin'|'gobernacion'|'all'}
 */
export function resolveMapZoneMode({tokenClientId, isAdmin, roleAgencyIds, agenciesTree}) {
  if (tokenClientId > 1) return 'gobernacion'
  if (isAdmin) return 'all'
  const ids = Array.isArray(roleAgencyIds) ? roleAgencyIds : []
  if (ids.some(id => agencyBelongsToDeant(id, agenciesTree))) return 'gobernacion'
  return 'medellin'
}

export function agencyBelongsToDeant(agencyId, agenciesTree) {
  const id = Number(agencyId)
  if (DEANT_AGENCY_IDS.indexOf(id) !== -1) return true
  if (!Array.isArray(agenciesTree) || agenciesTree.length === 0) return false

  const parentById = new Map()
  const walk = nodes => {
    nodes.forEach(node => {
      parentById.set(Number(node.id), node.parentId == null ? null : Number(node.parentId))
      if (Array.isArray(node.children) && node.children.length > 0) walk(node.children)
    })
  }
  walk(agenciesTree)

  const seen = new Set()
  let current = id
  while (parentById.has(current) && !seen.has(current)) {
    seen.add(current)
    if (current === DEANT_ROOT_AGENCY_ID) return true
    const parent = parentById.get(current)
    if (parent == null) return false
    current = parent
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/clientId.js